<template>
  <div>
    <sweet-modal ref="fields" width="60vw" :title="$t('ct-categories')">
      <table style="width: 100%" class="table table-striped">
        <thead>
        <th>{{ $t('ct-category') }}</th>
        <th>
          <button class="btn btn-primary float-right" @click="openAddField()"><i class="svg-icon svgi-add-page"></i>{{ $t('ct-add-category')}}
          </button>
        </th>
        </thead>
        <tr v-for="(field,index) in internal_config.tree" :key="keyComponent">
          <td>
            {{field.name}}
          </td>
          <td>
            <font-awesome-icon
              :icon="['far', 'trash-alt']"
              v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right danger text-danger"
              @click="removeEl(index)"
            />
            <font-awesome-icon
              :icon="['fas', 'pen']"
              v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right text-info"
              @click="editField(field)"
            />
            <font-awesome-icon
              :icon="['fas', 'chevron-down']"
              v-tooltip="{content:$t('ct-option-down'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right text-success"
              @click="changePosition(parseInt(index), parseInt(index)+1)"
            />
            <font-awesome-icon
              :icon="['fas', 'chevron-up']"
              v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right text-success"
              @click="changePosition(parseInt(index), parseInt(index)-1)"
            />
          </td>
        </tr>
      </table>

      <button slot="button" class="btn btn-outline-light" @click="$refs.fields.close()">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success" @click="saveAll()"><i class="svg-icon svgi-save"></i>{{ $t('ct-save') }}</button>
    </sweet-modal>

    <sweet-modal ref="addField" width="50vw" :title="$t('ct-edit-category')">

      <label>
        {{ $t('ct-category') }}
        <input type="text" class="form-control" v-model="itemEdition.name"/>
      </label>

      <label style="width: 100%;">{{ $t('ct-videos') }}</label>
      <table style="width: 100%" class="table table-striped">
        <thead>
        <th>{{ $t('ct-label') }}</th>
        <th>
          <button class="btn btn-primary float-right" @click="createNewSubItem()"><i class="svg-icon svgi-add-page"></i>{{ $t('ct-add-video') }}
          </button>
        </th>
        </thead>
        <tr v-for="(field,index) in itemEdition.childs">
          <td>
            {{ (typeof field.label !== 'undefined')  ? field.label : '' }}
          </td>
          <td>
            <font-awesome-icon
              :icon="['far', 'trash-alt']"
              v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right danger text-danger"
              @click="removeChild(index)"
            />
            <font-awesome-icon
              :icon="['fas', 'chevron-down']"
              v-tooltip="{content:$t('ct-option-down'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right text-success"
              @click="changePositionVideo(parseInt(index), parseInt(index)+1)"
            />
            <font-awesome-icon
              :icon="['fas', 'chevron-up']"
              v-tooltip="{content:$t('ct-option-up'),  class: 'tooltip-custom'}"
              class="font-awesome-icon float-right text-success"
              @click="changePositionVideo(parseInt(index), parseInt(index)-1)"
            />
            <font-awesome-icon :icon="['fas', 'pen']"
                               v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
                               class="font-awesome-icon float-right text-info"
                               @click="editChild(field)"/>
          </td>
        </tr>
      </table>

      <button slot="button" class="btn btn-outline-light" @click="$refs.addField.close()">{{ $t('ct-cancel')}}</button>
      <button slot="button" class="btn btn-success" @click="save"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>

    <sweet-modal ref="addChild" width="40vw">
      <label style="width: 100%;">
        {{ $t('ct-label') }}
        <input type="text" class="form-control" name="name" v-model="subitemEdition.label"/>
      </label>

      <label style="width: 100%;">
        {{ $t('ct-video-thumbnail') }}
        <div :style="{ backgroundImage: `url('${subitemEdition.thumbnail}')` }" class="modal-choose-box-image"/>
        <div class="d-block w-100 text-sm-center small">{{$t('ct-size-image-helper')}}</div>
        <button class="btn btn-primary btn-change-image d-block" @click="getImages">{{ $t('ct-change-image')}}
        </button>
      </label>

      <label style="width: 100%;">
        {{ $t('ct-video-url') }}
        <input type="text" class="form-control" name="name" v-model="subitemEdition.url" @blur="validURL"/>
      </label>

      <button slot="button" class="btn btn-outline-light" @click="$refs.addChild.close()">{{ $t('ct-cancel')}}</button>
      <button slot="button" class="btn btn-success" @click="addChild"><i class="svg-icon svgi-save"></i>{{ $t('ct-save')}}</button>
    </sweet-modal>

  </div>
</template>

<script>
  import {SweetModal} from 'sweet-modal-vue';

  export default {
    name: 'VideoGalleryConfigModals',
    components: {
      SweetModal
    },
    data() {
      return {
        keyComponent: 1,
        internal_config: false,
        callback: false,
        itemEdition: {},
        subitemEdition: {}
      };
    },
    methods: {
      isValidUrl(string) {
        try {
          new URL(string);
        } catch (_) {
          return false;
        }

        return true;
      },

      validURL() {

        console.log('aqio');

        try {
          let url = this.subitemEdition['url'] || '';

          if (typeof url !== undefined || url !== "") {

            if (url.indexOf('vidello') !== -1) {
              return url
            } else {
              //vimeo
              let matchVimeo = url.match(/(videos|video|channels|\.com)\/([\d]+)/);
              if (matchVimeo) {
                this.subitemEdition['url'] = "https://player.vimeo.com/video/" + matchVimeo[2] + "?";
              } else {
                let matchWistia = url.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/(.*)/);
                if (matchWistia) {
                  this.subitemEdition['url'] = "https://fast.wistia.com/embed/medias/" + matchWistia[4];
                } else {
                  let match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/);
                  if (match && match[2].length == 11) {
                    this.subitemEdition['url'] = "https://www.youtube.com/embed/" + match[2] + "?";
                  } else {
                    if (!this.isValidUrl(this.subitemEdition['url'])) {
                      this.subitemEdition['url'] = '';
                      this.$snotify.warning(this.$t('ct-need-valid-url'));
                    }
                  }
                }
              }
            }
          }
        } catch (e) {
          this.subitemEdition['url'] = '';
          this.$snotify.warning(this.$t('ct-need-valid-url'));
        }

      },
      createNewSubItem() {

        this.subitemEdition = Object.assign(
          {},
          {
            type: 'add',
            url: '',
            label: '',
            thumbnail: '',
            id: ''
          }
        );
        this.$refs.addChild.open();

      },

      init(config, callback = false) {
        this.internal_config = JSON.parse(JSON.stringify(config));
        this.callback = callback;
      },
      open(modal) {
        if (this.$refs[modal]) {
          this.$refs[modal].open()
        }
      },
      save() {
        if (this.itemEdition['type'] == 'add') {
          this.internal_config.tree[Object.keys(this.internal_config.tree).length] = JSON.parse(JSON.stringify(this.itemEdition));
        }

        this.$refs.addField.close();
        this.keyComponent++;
      },

      saveAll() {
        if (this.callback && typeof this.callback === 'function') {
          this.callback(JSON.parse(JSON.stringify(this.internal_config)));
          this.$refs['fields'].close();
        }
      },
      openEdition() {
        this.$refs.fields.open();
      },

      addChild() {

        let invalid = false;

        if (this.subitemEdition['url'] === '') {
          this.$snotify.warning(this.$t('ct-need-valid-url'));
          invalid = true;
        }
        if (this.subitemEdition['thumbnail'] === '') {
          this.$snotify.warning(this.$t('ct-need-valid-thumbnail'));
          invalid = true;
        }


        if (!invalid) {
          if (this.subitemEdition['type'] === 'add') {
            this.itemEdition.childs[Object.keys(this.itemEdition.childs).length] = JSON.parse(JSON.stringify(this.subitemEdition));
          }

          this.$refs.addChild.close();
          this.keyComponent++;
        }
      },

      openAddField() {
        this.itemEdition = Object.assign(
          {},
          {
            name: '',
            type: 'add',
            childs: {},
          }
        );
        this.$refs.addField.open();
      },
      editField(field) {
        this.itemEdition = field;
        this.itemEdition['type'] = 'edit';
        this.$refs.addField.open();
      },
      editChild(field) {
        this.subitemEdition = field;
        this.subitemEdition['type'] = 'edit';
        this.$refs.addChild.open();
      },
      removeEl(index) {
        delete this.internal_config.tree[index];
        this.keyComponent++;
      },

      getImages() {
        document.getElementsByClassName(
          "panel-components-right"
        )[0].style.zIndex = 0;

        let values = {
          action: "open",
          type: "Images",
          save: this.saveFile,
          close: this.closeFile
        };
        this.$root.$emit("fileMananger", values);
      },
      saveFile(image) {
        document
          .getElementsByClassName("panel-components-right")[0]
          .removeAttribute("style");

        this.subitemEdition.thumbnail = image;

        let values = {
          action: "close",
          type: "Files",
          save: this.saveFile,
          close: this.closeFile
        };
        this.$root.$emit("fileMananger", values);

      },
      closeFile() {
        document
          .getElementsByClassName("panel-components-right")[0]
          .removeAttribute("style");

        let values = {
          action: "close",
          type: "Files",
          save: this.saveFile,
          close: this.closeFile
        };
        this.$root.$emit("fileMananger", values);
      },


      removeChild(index) {
        delete this.itemEdition.childs[index]
        this.keyComponent++;
      },
      changePositionVideo(index, newIndex) {
        if (newIndex >= Object.keys(this.itemEdition.childs).length || newIndex < 0) {
          return;
        }

        let oldElement = JSON.parse(JSON.stringify(this.itemEdition.childs[index]));
        let newElement = JSON.parse(JSON.stringify(this.itemEdition.childs[newIndex]));


        this.itemEdition.childs[newIndex] = oldElement;
        this.itemEdition.childs[index] = newElement;

        this.keyComponent++;
      },
      changePosition(index, newIndex) {

        // console.log(newIndex, index)

        if (newIndex >= Object.keys(this.internal_config.tree).length || newIndex < 0) {
          return;
        }

        let oldElement = JSON.parse(JSON.stringify(this.internal_config.tree[index]));
        let newElement = JSON.parse(JSON.stringify(this.internal_config.tree[newIndex]));


        // console.log(this.internal_config.tree[newIndex], this.internal_config.tree[index])


        this.internal_config.tree[newIndex] = oldElement;
        this.internal_config.tree[index] = newElement;

        this.keyComponent++;
      },
    },
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .nav-item {
    position: relative;
  }

  .navbar-nav.flex-column .dropdown-menu {
    left: 100%;
    top: 0;
  }

  .modal-choose-box-image {
    width: 320px;
    height: 180px;
    border-radius: 10px;
    opacity: 1;
    display: block;
    transition: 0.5s ease;
    backface-visibility: hidden;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 auto;
  }

  .btn-change-image {
    display: block;
    margin: 5px auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/VideoGallery/Gallery/ConfigModals.vue